<core-button
    #coreButton
    [attr.fullspace]="fullspace"
    [attr.label]="label"
    [attr.variant]="variant">
</core-button>
